import { useMediaQuery } from "@chakra-ui/react";

function useSmallScreen() {
  const [smallScreen] = useMediaQuery("(max-width:480px)");
  const [midScreen] = useMediaQuery("(max-width: 768px)");

  return [smallScreen, midScreen];
}

export default useSmallScreen;
